import axios from 'axios';
import env from 'runtime.env';

export const baseURL = process.env.NODE_ENV === 'development' ? '' : env.RT_API;

const apiGatewayHeaders = {
  'content-type': 'application/json',
  accept: 'application/json',
};

export const apiGateWayBase = {
  baseURL: env.RT_SYNCHUB,
  headers: apiGatewayHeaders,
};

const base = {
  // if in development mode, requests are being proxied through localhost, so we don't need a baseURL
  baseURL,
  headers: {
    'content-type': 'application/json',
    accept: 'application/json',
    'access-control-allow-origin': '*',
    'access-control-allow-headers': 'open',
  },
};

export const createAPIService = (service, config = {}) => {
  const api = axios.create({
    ...base,
    ...config,
    headers: {
      ...base.headers,
      ...(config.headers || {}),
    },
  });

  api.interceptors.request.use(config => ({
    ...config,
    url: `${service}${config.url}`,
  }));

  return api;
};

// without CORS headers
export const createAPIServiceNoCors = (service, config = {}) => {
  const api = axios.create({
    ...base,
    ...config,
    headers: {
      'content-type': 'application/json',
      accept: 'application/json',
      ...(config.headers || {}),
    },
  });

  api.interceptors.request.use(config => ({
    ...config,
    url: `${service}${config.url}`,
  }));

  return api;
};

export const createFileUploadService = (config = {}) => {
  const fileUploadApi = axios.create({
    ...config,
    baseURL: env.RT_API,
    headers: {
      'content-type': 'multipart/form-data',
      ...(config.headers || {}),
    },
  });

  return fileUploadApi;
};

export const createFileVaultService = (config = {}) => {
  const fileVaultApi = axios.create({
    ...config,
    ...apiGateWayBase,
  });

  return fileVaultApi;
};
